<h2>Veranstaltungen</h2>
<div class="grid">
  <div class="col-12">
    <p-table [value]="timetableEntriesRelations" [rowTrackBy]="rowTrackBy" dataKey="id" sortMode="multiple">
      <ng-template pTemplate="header">
        <tr>
          <th>#</th>
          <th pSortableColumn="host">Dozierende</th>
          <th pSortableColumn="titleFilter">Titel</th>
          <th pSortableColumn="maxAttendees">Anzahl</th>
          <th pSortableColumn="slotFilter">Slot</th>
          <th pSortableColumn="roomFilter">Ort</th>
          <th pSortableColumn="typeFilter">Typ</th>
          <th></th>
        </tr>
        <tr>
          <th></th>
          <th pSortableColumn="host">
            <p-columnFilter display="menu" field="host"></p-columnFilter>
            <p-sortIcon field="host"></p-sortIcon>
          </th>
          <th pSortableColumn="titleFilter">
            <p-columnFilter display="menu" field="titleFilter"></p-columnFilter>
            <p-sortIcon field="titleFilter"></p-sortIcon>
          </th>
          <th pSortableColumn="maxAttendees">
            <p-sortIcon field="maxAttendees"></p-sortIcon>
          </th>
          <th pSortableColumn="slotFilter">
            <p-columnFilter field="slotFilter" display="menu"></p-columnFilter>
            <p-sortIcon field="slotFilter"></p-sortIcon>
          </th>
          <th pSortableColumn="roomFilter">
            <p-columnFilter display="menu" field="roomFilter"></p-columnFilter>
            <p-sortIcon field="roomFilter"></p-sortIcon>
          </th>
          <th pSortableColumn="typeFilter">
            <p-columnFilter display="menu" field="typeFilter"></p-columnFilter>
            <p-sortIcon field="typeFilter"></p-sortIcon>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-timetableEntry let-index="rowIndex" let-editing="editing">
        <tr>
          <td>{{index + 1}}</td>
          <td>
            {{timetableEntry.host}}
          </td>
          <td>
            @if (timetableEntry.subtitle) {
              <div class="subtitleRow">{{timetableEntry.subtitle|addZeroWidthSpace}}</div>
            }
            <div>{{timetableEntry.title|addZeroWidthSpace}}</div>
          </td>
          <td>
            {{timetableEntry.maxAttendees}}
          </td>
          <td>
            <edu-udo-itmc-dev-mini-book-date-display [date]="timetableEntry.timeslot?.date"></edu-udo-itmc-dev-mini-book-date-display><br />
            <edu-udo-itmc-dev-mini-book-time-display [time]="timetableEntry.timeslot?.start"></edu-udo-itmc-dev-mini-book-time-display>
            -
            <edu-udo-itmc-dev-mini-book-time-display [time]="timetableEntry.timeslot?.end"></edu-udo-itmc-dev-mini-book-time-display>
          </td>
          <td>
            <edu-udo-itmc-dev-mini-book-room-display [room]="timetableEntry.room" [online]="timetableEntry.online"></edu-udo-itmc-dev-mini-book-room-display>
          </td>
          <td>
            {{timetableEntry.type|translate}}
          </td>
          <td class="actionColumn">
            <p-button label="Aktionen" (click)="op.toggle($event)" ariaLabel="Aktionen öffnen"></p-button>
            <p-popover #op>
              <div class="flex flex-col gap-1">
                <p-button icon="pi pi-pencil" title="Eintrag bearbeiten"
                  (click)="op.hide(); onTimetableEntryEditInit(timetableEntry)"
                  [disabled]="clonedTimetableEntry && clonedTimetableEntry.id !== timetableEntry.id" ariaLabel="Eintrag bearbeiten"></p-button>
                <p-button icon="pi pi-list" (click)="op.hide();showAttendeeList(timetableEntry)" title="Teilnehmerliste anzeigen" ariaLabel="Teilnehmerliste anzeigen"></p-button>
                <p-button title="Teilnehmerliste exportieren" icon="pi pi-download"
                  (click)="op.hide();downloadAttendeeList(timetableEntry)" [disabled]="timetableEntry.attendeeCount===0" ariaLabel="Teilnehmerliste exportieren"></p-button>
                <p-button title="Teilnehmerliste löschen" icon="pi pi-times-circle"
                  (click)="deleteAllUsersEntry(timetableEntry)" [disabled]="timetableEntry.attendeeCount===0" ariaLabel="Teilnehmerliste löschen"></p-button>
                <p-button title="Eintrag löschen" icon="pi pi-trash"
                  (click)="deleteTimetableEntry(timetableEntry)" ariaLabel="Eintrag löschen"></p-button>
                <p-button title="Eintrag kopieren" icon="pi pi-copy"
                  (click)="op.hide(); onTimetableCopyEntryInit(timetableEntry)" ariaLabel="Eintrag kopieren"></p-button>
              </div>
            </p-popover>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex gap-2 justify-content-end align-items-center p-3">
          <p-button label="Veranstaltung hinzufügen" icon="pi pi-plus" (click)="addTimetableEntry()" ariaLabel="Veranstaltung hinzufügen"></p-button>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>
